
import RegionHeader from "@/components/region/RegionHeader"
import RegionToolbar from "@/components/layout/navigation/RegionToolbar"
import TagFilter from "@/components/search/TagFilter"
import SearchResult from "@/components/search/v2/SearchResult"

import regionMeta from "@/mixins/regionMeta"
import currentYearMixin from "@/mixins/currentYearMixin"
import regionSearchRouting from "@/models/regionSearchRouting"
import ApprenticeshipSearch from "@/components/search/ApprenticeshipSearch"

export default {
    meta: {
        toolbar: {
            hideSearch: true,
        },
        footer: {
            showPowered: true,
        },
    },
    components: {
        ApprenticeshipSearch,
        RegionToolbar,
        RegionHeader,
        TagFilter,
        SearchResult,
    },

    mixins: [currentYearMixin, regionMeta],
    watchQuery: true,
    async asyncData({ store, route, $axios }) {
        let categories = regionSearchRouting.getRouting(route)

        const response = await $axios.$get("/api/regions/" + route.params.slug)
        const region = response.data
        await store.dispatch("search/init", {
            categories: categories,
            selectedCategory: "Ausbildung",
            locationSlug: route.params.slug,
            query: route.query,
            channel: region.channel.slug,
            type: "region",
        })
        return {
            region: region,
        }
    },
    data: () => {
        return {
            region: {},
        }
    },
    head() {
        return {
            title:
                this.region.name +
                ": Ausbildungsstellen in den besten Betrieben",
            meta: [
                {
                    hid: "description",
                    name: "description",
                    content:
                        this.region.name +
                        ": Entdecke freie Ausbildungsstellen, die dich interessieren. Lokal von den besten Firmen in der Region.",
                },
                {
                    hid: "og:title",
                    name: "og:title",
                    content:
                        this.region.name +
                        ": Ausbildungsstellen in den besten Betrieben",
                },
                {
                    hid: "og:description",
                    name: "og:description",
                    content:
                        this.region.name +
                        ": Entdecke freie Ausbildungsstellen, die dich interessieren. Lokal von den besten Firmen in der Region.",
                },
                ...this.getOgImage(),
            ],
        }
    },
}
